<template>
  <div class="fd-w-full fd-bg-white fd-rounded-lg fd-px-4 fd-pt-6 fd-pb-2" style="min-height: 100%; height: auto;">
    <Table
      :name="name"
      :total="total"
      :fields="fields"
      :items="properties"
      :hasFilter="true"
      :hasSearch="true"
      :perPage="10"
      :isBusy="isBusy"
      @changedPage="setPage"
      @setSearch="setSearch"
      @showRemoveComponent="showRemoveComponent"
      @showEditComponent="editProperty"
      @viewComponent="showProperty"
      @applyFilter="applyFilter"
      @clearAllFilters="clearAllFilters"
      :hasViewIcon="true"
    >
      <template #filters>
        <PropertyFilter @filters="setFilters" type="complex" />
      </template>
      <template #footer-tab>
        <div>
          <button
            @click.prevent="showImportProperty"
            class="fd-block fd-w-9 fd-h-9 fd-border fd-border-theme-4 fd-flex fd-justify-center fd-items-center fd-rounded-lg"
          >
            <SvgLoader :name="'exportIcon'" />
          </button>
          <button
            @click.prevent="showAddPropertySidebar"
            class="fd-block fd-w-9 fd-h-9 fd-bg-theme-4 fd-flex fd-justify-center fd-items-center fd-mt-2 fd-rounded-lg"
          >
            <SvgLoader :name="'add'" />
          </button>
        </div>
      </template>
    </Table>

    <ConfirmDialogue @remove="removeProperty" />

    <div>
      <b-sidebar
        id="import-sidebar"
        no-header
        bg-variant="white"
        shadow right lazy backdrop
        :backdrop-variant="'dark'"
      >
        <template #default="{ hide }">
          <ImportProperty :postAction="`/complex/${$route.params.id}/property/import`" />
        </template>
      </b-sidebar>

      <b-sidebar
        id="add-property-sidebar"
        no-header
        bg-variant="white"
        shadow right lazy backdrop
        :backdrop-variant="'dark'"
      >
        <template #default="{ hide }">
          <PropertyForm
            type="complex"
            :isUpdate.sync="isUpdate"
            :readOnly.sync="readOnly"
            :propertyId="propertyId"
            @setForm="setForm"
            @saveData="save"
          />
        </template>

      </b-sidebar>
    </div>
  </div>
</template>

<script>
import Table from "@/views/components/global/Table";
import {mapGetters} from "vuex";
import { BButton, BSidebar } from 'bootstrap-vue'
import PropertyFilter from "@/views/components/ProjectManagement/property/PropertyFilter";
import ImportProperty from "@/views/components/ProjectManagement/property/ImportProperty";
import PropertyForm from "@/views/components/ProjectManagement/property/PropertyForm";
import ConfirmDialogue from "@/views/components/global/ConfirmDialogue";
import toast from "@/mixins/toast";

export default {
  name: "Property",
  mixins: [toast],
  components: {ConfirmDialogue, PropertyForm, ImportProperty, PropertyFilter, Table, BButton, BSidebar},
  data() {
    return {
      loading: false,
      btnTitle: null,
      isUpdate: false,
      readOnly: false,
      propertyId: null,
      search: '',
      filters: '',
      itemId: null,
      complexName: null,
      form: null,
    }
  },
  async created() {
    await this.$store.dispatch('complex/getComplexDetails', this.$route.params.id).then(res => {
      this.complexName = res.name
    })
    let data = {
      complexName: this.complexName
    }
    this.getData(data)
  },
  watch: {
    search: {
      handler(newVal) {
        let data = {
          complexName: this.complexName
        }
        if (newVal) {
          data.search = newVal
        }
        this.getData(data)
      }
    }
  },
  computed: {
    ...mapGetters({
      properties: 'complex/complexProperties',
      total: 'complex/complexPropertiesTotal'
    }),
    fields() {
      return [
        { key: 'phase', label: 'PHASE' },
        { key: 'complex', label: 'COMPLEX' },
        { key: 'template', label: 'TEMPLATE' },
        { key: 'type', label: 'TYPE' },
        { key: 'floor', label: 'FLOOR' },
        { key: 'rooms', label: 'ROOMS' },
        { key: 'unit_number', label: 'UNIT NUM' },
        { key: 'net', label: 'NET' },
        { key: 'gross', label: 'GROSS' },
        { key: 'price', label: 'PRICE' },
        { key: 'status', label: 'STATUS', sortable: true },
        { key: 'actions', label: 'ACTIONS', class: 'text-right' }
      ]
    },
    name() {
      return 'Properties'
    },
    isBusy() {
      return this.loading
    }
  },
  methods: {
    getData(data) {
      this.loading = true
      data.id = this.$route.params.id
      this.$store.dispatch('complex/getComplexProperties', data).finally(() => {
        this.loading = false
      })
    },
    setPage(number) {
      let data = {
        complexName: this.complexName,
        number
      }
      if (this.search) {
        data.search = this.search
      }
      this.getData(data)
    },
    setSearch(search) {
      this.search = search
    },
    setFilters(filters) {
      this.filters = filters
    },
    showImportProperty() {
      this.$root.$emit('bv::toggle::collapse', 'import-sidebar')
    },
    showAddPropertySidebar() {
      this.$root.$emit('bv::toggle::collapse', 'add-property-sidebar')
    },
    removeProperty() {
      this.$store.dispatch('complex/deleteProperty', this.itemId).then((response) => {
        this.makeToast(this.makeToast(response.data.message))
        let data = {
          complexName: this.complexName
        }
        if (this.search) {
          data.search = this.search
        }
        if (this.filters) {
          data.filters = this.filters
        }

        this.getData(data)
      })
        .finally(() => {
          this.itemId = null
          this.toggleConfirmDialogue()
        })
    },
    showRemoveComponent(id) {
      this.itemId = id
      this.toggleConfirmDialogue()
    },
    toggleConfirmDialogue() {
      this.$root.$emit("bv::toggle::modal", "confirmDialogue");
    },
    editProperty(id) {
      this.isUpdate = true
      this.propertyId = id
      this.showAddPropertySidebar()
    },
    showProperty(id) {
      this.readOnly = true
      this.propertyId = id
      this.showAddPropertySidebar()
    },
    setForm(formData) {
      this.form = formData
    },
    save(actionType) {
      let data = {
        id: this.$route.params.id,
        data: JSON.parse(JSON.stringify(this.form))
      }
      data.data.phase_id = data.data.phase.id
      data.data.complex_id = data.data.complex.id
      data.data.template_id = data.data.template.id
      data.data.discount_percent = data.data.payment.cash.discount
      data.data.public_price = data.data.main_price
      data.data.installment_discount_percent = data.data.payment.installment.discount
      data.data.installment_month_count = data.data.payment.installment.month

      const whiteList = ['complex_id', 'template_id', 'phase_id', 'extra_info', 'visibility', 'floor', 'unit_number', 'public_price', 'discount_percent', 'installment_discount_percent', 'installment_month_count']
      const checkNumberList = ['floor', 'unit_number', 'public_price', 'discount_percent', 'installment_discount_percent', 'installment_month_count']

      Object.keys(data.data).forEach(key => {
        if (!whiteList.includes(key)) {
          delete data.data[key]
        }
        if (actionType === 'createNewProperty' && (data.data[key] === "" || data.data[key] === null)) {
          delete data.data[key]
        } else {
          if (checkNumberList.includes(key)) {
            data.data[key] = Number(data.data[key])
          }
        }
      })

      if (this.isUpdate) {
        data.propertyId = this.propertyId
      }
      this.$store.dispatch(`complex/${actionType}`, data).then(() => {
        data = {
          complexName: this.complexName
        }
        this.getData(data)
        this.showAddPropertySidebar()
      })
    },
    applyFilter() {
      if (!this.filters) return

      let data = {
        complexName: this.complexName,
        filters: this.filters
      }
      if (this.search) {
        data.search = this.search
      }
      this.getData(data)
    },
    clearAllFilters() {
      this.search = ''
      let data = {
        complexName: this.complexName
      }
      this.getData(data)
    }
  }
}
</script>

<style scoped>

</style>